import { motion } from "framer-motion";

// A minimal vector motif inspired by the Brahmsara logo:
// a standing figure, a radiant halo and a crowning starburst.
export function SignatureSymbol({ className = "", color = "var(--gold)" }) {
  return (
    <svg viewBox="0 0 200 210" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      {/* halo */}
      <ellipse cx="100" cy="78" rx="72" ry="30" stroke={color} strokeWidth="1.2" opacity="0.7" />
      {/* crowning starburst */}
      <path d="M100 20 L103.5 40 L120 44 L103.5 48 L100 68 L96.5 48 L80 44 L96.5 40 Z" fill={color} />
      {/* figure */}
      <circle cx="100" cy="70" r="9" fill={color} />
      <path
        d="M100 82 C92 82 88 88 88 95 L88 130 C88 137 91 142 95 143 L96 176 C96 181 104 181 104 176 L105 143 C109 142 112 137 112 130 L112 95 C112 88 108 82 100 82 Z"
        fill={color}
      />
      {/* heart light */}
      <path d="M100 100 L102 108 L110 110 L102 112 L100 120 L98 112 L90 110 L98 108 Z" fill="var(--noir)" opacity="0.9" />
    </svg>
  );
}

// A slim centered divider using the symbol between sections.
export function SignatureDivider({ dark = false }) {
  const line = dark ? "rgba(233,172,70,0.35)" : "rgba(200,149,54,0.4)";
  const symColor = dark ? "var(--gold-bright)" : "var(--gold)";
  return (
    <div className="section-pad py-16 flex items-center justify-center gap-6" data-testid="signature-divider">
      <span className="h-px flex-1 max-w-[180px]" style={{ background: `linear-gradient(90deg, transparent, ${line})` }} />
      <motion.div
        initial={{ opacity: 0, scale: 0.8, y: 10 }}
        whileInView={{ opacity: dark ? 0.9 : 0.8, scale: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
      >
        <SignatureSymbol className="w-8 h-9" color={symColor} />
      </motion.div>
      <span className="h-px flex-1 max-w-[180px]" style={{ background: `linear-gradient(90deg, ${line}, transparent)` }} />
    </div>
  );
}

export default SignatureSymbol;
